export default "__VITE_ASSET__C7IDGn2X__"